import { HIDE_GOOGLE_ONE_TAP, HIDE_REG_LOGIN_LIGHTBOX, SET_REG_LOGIN_INPUT_VALUES, SET_REG_LOGIN_NODE, SET_REG_LOGIN_PATH, SET_REG_LOGIN_REDIRECT_URL, SET_RESET_PASSWORD_LINK_URL, SET_REG_LOGIN_UI_CONFIG, SET_REG_LOGIN_UI_CONFIG_DEFAULTS, SET_REG_LOGIN_ZMA_HANDLERS, SET_PASSWORD_REQUIRED, SHOW_GOOGLE_ONE_TAP, SHOW_REG_LOGIN_LIGHTBOX, } from '../constants/actions';
export const DEFAULT_UI_CONFIG = {
    headerText: 'Welcome to Zillow',
    gaLabel: 'generic/generic',
    showTabs: true,
    renderNodeTarget: null,
    disableEmailForm: false,
    showProRegCheckbox: true,
};
const initialState = {
    inputValues: {},
    path: '/',
    redirectUrl: '',
    showLightbox: false,
    uiConfig: DEFAULT_UI_CONFIG,
};
/**
 * Reduces register state.
 */
export const regLoginReducer = (state = initialState, action) => {
    switch (action.type) {
        case HIDE_GOOGLE_ONE_TAP:
            return {
                ...state,
                showGoogleOneTap: false,
            };
        case HIDE_REG_LOGIN_LIGHTBOX:
            return {
                ...state,
                showLightbox: false,
            };
        case SET_REG_LOGIN_INPUT_VALUES:
            return {
                ...state,
                inputValues: { ...state.inputValues, ...action.inputValues },
            };
        case SET_REG_LOGIN_NODE:
            return {
                ...state,
                node: action.node,
            };
        case SET_REG_LOGIN_PATH:
            return {
                ...state,
                path: action.path,
            };
        case SET_REG_LOGIN_REDIRECT_URL:
            return {
                ...state,
                redirectUrl: action.redirectUrl,
            };
        case SET_REG_LOGIN_UI_CONFIG:
            return {
                ...state,
                uiConfig: {
                    ...state.uiConfig,
                    ...(action.uiConfig || DEFAULT_UI_CONFIG),
                },
            };
        case SET_REG_LOGIN_UI_CONFIG_DEFAULTS:
            return {
                ...state,
                uiConfig: {
                    ...DEFAULT_UI_CONFIG,
                    ...(action.uiConfig || {}),
                },
            };
        case SET_REG_LOGIN_ZMA_HANDLERS:
            return {
                ...state,
                zmaHandlerFns: action.zmaHandlerFns,
            };
        case SET_PASSWORD_REQUIRED:
            return {
                ...state,
                requiresPassword: action.requiresPassword,
            };
        case SET_RESET_PASSWORD_LINK_URL:
            return {
                ...state,
                resetPasswordLinkUrl: action.resetPasswordLinkUrl,
            };
        case SHOW_GOOGLE_ONE_TAP:
            return {
                ...state,
                showGoogleOneTap: true,
            };
        case SHOW_REG_LOGIN_LIGHTBOX:
            return {
                ...state,
                showLightbox: true,
            };
        default:
            return state;
    }
};
